import * as React from "react";
import { EventName } from "../EventName";
import { getPrePacksPrefix } from "../../components";
import { ToggleSGPBadge } from "../ToggleSGPBadge";
export const PrePacksHeader = React.memo(function PrePacksHeader(props) {
    const baseClasName = getPrePacksPrefix("prePacks");
    const eventClasName = getPrePacksPrefix("event");
    const EventNameWithLink = React.useCallback(() => props.getEventPageNavLink({ children: React.createElement(EventName, Object.assign({}, props.eventName)) }), []);
    return (React.createElement("div", { className: `${baseClasName}-header-wrapper` }, props.scoreboard || React.createElement(React.Fragment, null,
        React.createElement("div", { className: `${baseClasName}-header`, "data-testid": "prepacks-event-header" },
            React.createElement(EventNameWithLink, null)),
        React.createElement("div", { className: `${baseClasName}-sub-header` },
            React.createElement(ToggleSGPBadge, { tags: props.tags, title: props.sgpBadgeTitle, renderSGPNavLink: props.renderSGPNavLink }),
            props.startDate && React.createElement("div", { className: `${eventClasName}-date` }, props.startDate)))));
});
//# sourceMappingURL=PrePacksHeader.js.map